import React from "react";
import { Link } from "react-router-dom";

export default function Breadcrumb({ title = "About Us" }) {
  return (
    <div className="page-header">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="page-header-box">

              {/* Page Title */}
              <h1
                className="text-anime-style-3"
                style={{ perspective: "400px", textAlign: "center" }}
              >
                {title}
              </h1>

              {/* Breadcrumb */}
              <nav
                className="wow fadeInUp"
                data-wow-delay="0.25s"
              >
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    aria-current="page"
                  >
                    {title}
                  </li>
                </ol>
              </nav>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
